import createDataContext from "./createDataContext";
import { getDate, isPast } from "date-fns";


var axios = require("axios");
var _ = require("lodash");
var qs = require("qs");

const reducer = (state, action) => {
  switch (action.type) {
    case "update_deals":
      if (state.deals !== action.payload) {
        return {
          ...state,
          deals: action.payload.deals,
          selectedDeal: action.payload.selectedDeal,
        };
      } else {
        return;
      }
    case "set_selected_deal":
      return {
        ...state,
        selectedDeal: action.payload.selectedDeal,
      };
    default:
      return state;
  }
};

const getDeals = (dispatch, history) => async () => {
    try{
      const response = await axios({
          method: "post",
          data: qs.stringify({
            method: "getDeals",
          }),
          withCredentials: true,
        });


      if (response.data.status === 0) {
        sessionStorage.remove("authenticated");
      }
      let dealsResponse = response.data.deals;

      dispatch({
        type: "update_deals",
        payload: {
          deals: dealsResponse,
          selectedDeal: dealsResponse[0],
        },
      });
    } catch {
      console.log("ERrrrrror getting Deals");
    }

    

};


const setSelectedDeal = (dispatch, history) => async (deal) => {
    try{
      dispatch({
        type: "set_selected_deal",
        payload: {
          selectedDeal: deal,
        },
      });

    } catch {
      console.log("ERrrrrror setting Deal");
    }
}




export const { Provider, Context } = createDataContext(
  reducer,
  {
    getDeals,
    setSelectedDeal,
  },
  {
    deals: [],
    selectedDeal: {},
  }
);
